import { Component, OnInit } from '@angular/core';
import '@angular/localize/init';
import { ActivatedRoute } from '@angular/router';
import { RfidCardDto } from '@dto/rfidCardDto';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { ClaimRfidCardRequest } from '@dto/claimRfidCardRequest';

@Component({
  selector: 'app-claim-autochargeId',
  templateUrl: './claim-autochargeId.component.html',
  styleUrls: ['./claim-autochargeId.component.scss']
})
export class ClaimAutochargeIdComponent implements OnInit {
  
  public whitelabel: string
  public whitelabelURL: string = 'https://cubosgeneralstorage.blob.core.windows.net/whitelabel-storage/'

  private userId: string
  private rfidCardId: number
  private token: string

  public rfidCard: RfidCardDto

  public isConfirmed: boolean = false;
  public isSuccess: boolean

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService
  ) { }

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  ngOnInit(): void {
    this.userId = this.route.snapshot.queryParams['userId'];
    this.rfidCardId = this.route.snapshot.queryParams['rfidCardId'];
    this.token = this.route.snapshot.queryParams['token'];
    this.token = this.token.split(' ').join('+') // Decode the Uri-Parameter

    
    
    // this.claimRfidCard();
  }
  
  ngAfterViewInit() {
    this.whitelabel = localStorage.getItem('whitelabel');
  }

  claimRfidCard() {
    const request: ClaimRfidCardRequest = {
      rfidCardId: this.rfidCardId,
      userId: this.userId,
      token: this.token
    }
    this.authService.claimRfidCard(request).subscribe(result => {
      this.isSuccess = true;
      this.isConfirmed = true
    }, error => {
      this.isSuccess = false;
      this.isConfirmed = true
      console.error(error);
    })
  }
}